<template>

  <footer>
    <div>
      <div class="container-fluid footer-links footer-border-bottom footer-border-top">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-sm-6 mt-4">
              <span>{{$t('Xarxa de col·laboració UPC').toUpperCase()}}</span>
              <ul>
                <li><router-link-locale :to="{name: 'professorat', params: {page: 1, sort: 'professor_nom_sort asc'}}">{{$t('Professorat')}}</router-link-locale></li>
                <li><router-link-locale :to="{name: 'organitzacions', params: {page: 1, sort: 'organitzacio_nom_ca asc'}}">{{$t('Organització')}}</router-link-locale></li>
                <li><router-link-locale :to="{name: 'assignatures', params: {page: 1, sort: 'assignatura_nom_ca asc'}}">{{$t('Assignatures')}}</router-link-locale></li>
                <li><router-link-locale :to="{name: 'titulacions', params: {page: 1, sort: 'titulacio_sigles asc'}}">{{$t('Titulacions')}}</router-link-locale></li>
              </ul>
            </div>
            <div class="col-md-3 col-sm-6 mt-4">
              <span>{{$t('Materials').toUpperCase()}}</span>
              <ul>
                <li><router-link-locale :to="{name: 'activitats', params: {page: 1, sort: 'data desc, activitat_data_available desc'}}">{{$t('Activitats')}}</router-link-locale></li>
                <li><router-link-locale :to="{name: 'innovacio', params: {page: 1, sort: 'data desc, activitat_data_available desc'}}">{{$t('Innovacio')}}</router-link-locale></li>
                <li><router-link-locale :to="{name: 'materials', params: {page: 1, sort: 'data desc, activitat_data_available desc'}}">{{$t('subtipus')}}</router-link-locale></li>
                <li><router-link-locale :to="{name: 'accesObert', params: {page: 1, sort: 'data desc, activitat_data_available desc'}}">{{$t('Accés Obert')}}</router-link-locale></li>
                <li><router-link-locale :to="{name: 'treballsFinals', params: {page: 1, sort: 'data desc, activitat_data_available desc'}}">{{$t('Treballs Finals')}}</router-link-locale></li>
                <li><router-link-locale :to="{name: 'videos', params: {page: 1, sort: 'data desc, activitat_data_available desc'}}">{{$t('Vídeos')}}</router-link-locale></li>
              </ul>
            </div>
            <div class="col-md-3 col-sm-6 mt-4">
              <span>{{$t('Bibilioteques').toUpperCase()}}</span>
              <ul class="acces-directe">
                <li class=""><span class="lletra-cercle-u color-blaucel me-1"></span><a href="https://upcommons.upc.edu" target="_blank">UPCommons</a></li>
                <li class=""><span class="lletra-cercle-f color-blau me-1"></span><a href="https://futur.upc.edu" target="_blank">Futur</a></li>
                <li class=""><span class="lletra-cercle-b color-lila me-1"></span><a href="https://bibliotecnica.upc.edu" target="_blank">Bibliotecnica</a></li>
                <li class=""><span class="lletra-cercle-g color-morat me-1"></span><a href="https://geocommons.upc.edu" target="_blank">GeoCommons</a></li>
                <li class=""><span class="lletra-cercle-r color-verd me-1"></span><a href="https://revistes.upc.edu" target="_blank">Revistes UPC</a></li>
                <li class=""><span class="lletra-cercle-d color-groc me-1"></span><a href="https://doi.upc.edu" target="_blank">DOIBoard</a></li>
              </ul>
            </div>
            <div class="col-md-3 col-sm-6 mt-4">
              <span>UPC<br></span>
              <ul class="acces-directe">
                <li><span class="lletra-cercle-a lletra-cercle-petita color-blaucel"></span><a href="https://atenea.upc.edu" target="_blank">Atenea</a></li>
                <li><span class="lletra-cercle-e lletra-cercle-petita color-blau"></span><a href="https://prisma-nou.upc.edu/apl/home_estudiants.php?idioma=1" target="_blank" data-linktype="external" data-val="https://prisma-nou.upc.edu/apl/home_estudiants.php?idioma=1">E-Secretaria</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-lila"></span><a href="https://seuelectronica.upc.edu" target="_blank" data-linktype="external" data-val="https://seuelectronica.upc.edu">Seu electrònica</a></li>
                <li><span class="lletra-cercle-i lletra-cercle-petita color-morat"></span><a href="https://www.upc.edu/identitatdigital/ca" target="_blank" data-linktype="external" data-val="https://serveistic.upc.edu/ca">Identitat digital</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-blau"></span><a href="https://serveistic.upc.edu/ca" target="_blank" data-linktype="external" data-val="https://serveistic.upc.edu/ca">Serveis TIC</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-ver"></span><a href="https://community.vortal.biz/PRODSTS/Users/Login/Index?SkinName=UPC" target="_blank" data-linktype="external" data-val="https://community.vortal.biz/PRODSTS/Users/Login/Index?SkinName=UPC">Licitació electrònica</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-vermell"></span><a target="_blank" data-linktype="external" href="https://portal.personal.upc.edu/" data-val="https://portal.personal.upc.edu/">Portal del Personal UPC</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-vermell"></span><a href="https://directori.upc.edu" target="_blank" data-linktype="external" data-val="https://directori.upc.edu">Directori PDI i PTGAS</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-violeta"></span><a href="https://www.upc.edu/comunicacio/ca/identitat" target="_blank" data-linktype="external" data-val="https://www.upc.edu/comunicacio/ca/identitat">Marca corporativa</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-morat"></span><a href="https://upc-shop.com/" target="_blank" data-linktype="external" data-val="https://www.upc.edu/comunicacio/ca/identitat">UPCshop, marxandatge</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-verd"></span><a data-val="5b6460ec46c3430a883035f1f548bcf2" href="https://www.upc.edu/ca/sala-de-premsa" data-linktype="internal">Sala de premsa</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-blau"></span><a href="https://www.upc.edu/prevencio/ca" target="_blank" data-linktype="external" data-val="https://www.upc.edu/prevencio/ca">Seguretat i salut</a></li>
                <li><span class="lletra-cercle-s lletra-cercle-petita color-verd"></span><a href="https://autoproteccio.upc.edu/ca" target="_blank" data-linktype="external" data-val="https://autoproteccio.upc.edu/ca">Autoprotecció i emergències</a></li>

              </ul>
            </div>
          </div>
        </div>
      </div>


      <div class="container">
        <div class="pre-footer mt-2">

          <a href="https://www.upc.edu/idp/ca" target="_blank" rel="noreferrer noopener" title="Iniciativa Digital Politècnica">
            <img src="@/assets/images/partners/idp.jpg" alt="Iniciativa Digital Politècnica" title="Iniciativa Digital Politècnica" class="grayscale" height="40">
          </a>
          <a href="https://bibliotecnica.upc.edu/" target="_blank" rel="noreferrer noopener" title="Servei de Biblioteques, Publicacions i Arxius">
            <img src="@/assets/images/partners/sbpa.png" alt="Servei de Biblioteques, Publicacions i Arxius" title="Servei de Biblioteques, Publicacions i Arxius" class="grayscale" height="40">
          </a>
          <a href="https://www.ice.upc.edu/ca" target="_blank" rel="noreferrer noopener" title="Institut de Ciències de l'Educació">
            <img src="@/assets/images/partners/ice.png" alt="Institut de Ciències de l'Educació" title="Institut de Ciències de l'Educació" class="grayscale" height="40">
          </a>
          <a href="https://prisma-nou.upc.edu/" target="_blank" rel="noreferrer noopener" title="Oficina Prisma">
            <img src="@/assets/images/partners/prisma.png" alt="Oficina Prisma" title="Oficina Prisma" class="grayscale" height="40">
          </a>
          <a href="https://atenea.upc.edu" target="_blank" rel="noreferrer noopener" title="Atenea">
              <img src="@/assets/images/partners/atenea.png" alt="ATENEA" title="Atenea" class="grayscale">
          </a>
          <a href="https://drac.upc.edu/" target="_blank" rel="noreferrer noopener" title="DRAC. Descriptor de la Recerca i l'Activitat Acadèmica de la UPC">
              <img src="@/assets/images/partners/drac.jpg" alt="DRAC. Descriptor de la Recerca i l'Activitat Acadèmica de la UPC" title="DRAC. Descriptor de la Recerca i l'Activitat Acadèmica de la UPC" class="grayscale">
          </a>
        </div>
      </div>


      <div class="post-footer footer-border-bottom footer-border-top">
        <div class="container d-flex pt-3 pb-3">
          <div class="p-3"><span>© UPC - </span>Universitat Politècnica de Catalunya · BarcelonaTech</div>
          <div class="ms-auto d-flex">
            <div class="p-3"><router-link-locale class="text-dark" :to="{name: 'contact'}">{{$t('Contacte')}}</router-link-locale></div>
            <div class="p-3"><a class="text-dark" href="https://apren.upc.edu/api/RSS" target="_blank">RSS</a></div>
            <div class="p-3"><a class="text-dark" href="https://www.upc.edu/ca/avis-legal/accessibilitat">{{$t('Accessibilitat')}}</a></div>
            <div class="p-3"><a class="text-dark" href="https://www.upc.edu/ca/avis-legal">{{$t('Avís legal')}}</a></div>
          </div>
        </div>
      </div>

    </div>

  </footer>


</template>

<script>

  import RouterLinkLocale from "@/components/RouterLinkLocale.vue";

  export default {
    name: "FooterSection",
    components: {RouterLinkLocale},

    setup(){

      return{

      }

    }


  }

</script>

<style scoped>

  .footer-border-bottom {
    border-bottom: 1px solid #d4d5cf;
  }

  .footer-border-top {
    border-top: 1px solid #d4d5cf;
  }

  .pre-footer{
    background: #fff;
    text-align: justify-all;
    width: 100%;
    box-sizing: border-box
  }

  .pre-footer a{
    display: inline-block;
    height: 50px;
    margin: 15px;
  }


  .pre-footer a img{
    max-height: 100%;
    width: auto;
    display: block;
    border: 0;
    opacity: 0.9;
    -webkit-transition: .2s;
    transition: .2s;
  }

  .pre-footer a:hover img{
    opacity: 10;
  }

  .footer-links{
    background-color:#F6F7F7;
    text-align: justify;
    box-shadow:500px 0 0 0 #F6F7F7, -500px 0 0 0 #F6F7F7
  }

  .footer-links span {
    color:#636363;
    font-weight:700;
    font-size: 13px;
  }

  .footer-links ul {
    padding-left:12px;
    padding-bottom:18px;
    margin-top: 4px;

  }

  .footer-links li {
    font-size:.8125rem;
    padding:4px 0;
    list-style: none;
    -webkit-column-break-inside:avoid;
    page-break-inside:avoid;
    break-inside:avoid;


  }
  .footer-links li:before {
    content: "\f105"; /* Código Unicode para el icono de Font Awesome "angle-right" */
    /*content: "\f111"; /* Código Unicode para el icono de Font Awesome "circle" */
    font-family: "Font Awesome 5 Free";
    font-weight: 900; /* Necesario para los iconos sólidos */
    position:absolute;
    margin-left:-12px;
    font-size:7px;
    margin-top:3px;
    color:#636363
  }
  .footer-links li a {
    color:#636363;
    font-size: 13px;
    font-weight:400
  }

  .footer-links li a:hover {
    color:initial
  }

  .footer-links li a[target="_blank"]::after {
    content: "\f08e"; /* Código Unicode para el icono de Font Awesome "circle" */
    font-family: "Font Awesome 5 Free";
    font-weight: 700; /* Necesario para los iconos sólidos */
    font-size:66.6666667%;
    margin-left:3px;
    top:0;
    position:relative;
    display:inline-block
  }

  .footer-links .acces-directe li{
    list-style: none;
    margin-left: -12px;
  }

  .footer-links .acces-directe li:before {
    top:-10px;

  }

  .footer-links .acces-directe li a {
    font-weight:700;
    font-size: 13px;
    /*color:#007BC1*/
    color:#01559B
  }
  .footer-links .acces-directe li a:hover {
    color:#01559B
  }

  .post-footer {
    background-color: whitesmoke !important;
    font-weight: 300;
    font-size: 14px;
  }

</style>
